"use strict";require("polythene/base-button/theme/theme");
//# sourceMappingURL=base-button.js.map